window.Highcharts = require('highcharts');
import '../src/stock/stock2.js'
import '../src/stock/report_error.js'
import '../src/stock/email_registration.js'
import "bootstrap-table";
import "../src/filer/bootstrap-table-mobile.js"
import 'bootstrap-table/dist/bootstrap-table.css';
import "../src/filer/bootstrap-table-sticky-header.js"
import "../src/filer/bootstrap-table-sticky-header.css"
import "../src/filer/bootstrap-table-jumpto.css"
import "../src/filer/bootstrap-table-jumpto.js"
window.numbro = require('numbro');

import '../src/mutual_fund/mutual_fund_tables.js'
window.Highcharts = require('highcharts/highstock');
require('highcharts/modules/full-screen')(Highcharts);
require("highcharts/highcharts-more")(Highcharts);
require("highcharts/modules/drag-panes")(Highcharts);
require("highcharts/modules/annotations-advanced")(Highcharts);
require("highcharts/modules/full-screen")(Highcharts);
require("highcharts/modules/price-indicator")(Highcharts);
require("highcharts/modules/stock-tools")(Highcharts);
require("highcharts/modules/heikinashi")(Highcharts);
require("highcharts/modules/hollowcandlestick")(Highcharts);

require("highcharts/indicators/indicators-all")(Highcharts);
require("highcharts/themes/high-contrast-dark")(Highcharts);


import "core-js/stable";
import "regenerator-runtime/runtime";

import Vue from 'vue'


import '../src/common/styles/dashboard.scss'

Vue.config.productionTip = false
// Apply packages

const opts={
    icons: {
        iconfont: 'md' // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4'
    },
    theme: {
        themes: {
            light: {
                'primary': '#66C6BA',
                'primary-light': '#99F9EC',
                'primary-dark': '#30958A',
                'accent': '#FFB783',
                'accent-light': '#FFE9B3',
                'accent-dark': '#C98755',
                'base-bg': '#FAFAFA',
                'blue': '#7293CB',
                'navy-blue': '#196B8F',
                'dark-blue': '#303F48'
            }
        }
    }

}
import Vuetify from 'vuetify'
Vue.use(Vuetify)
import metricstore from '../src/stock/stock_metric/';
import 'vuetify/dist/vuetify.min.css'
import 'highcharts/css/annotations/popup.scss'

Vue.config.productionTip = process.env.NODE_ENV === 'production'
import MetricApp from '../src/stock/stock_metric_chart.vue'

new Vue({
    vuetify: new Vuetify(opts),
    el: "#metric-chart-container",
    //   router,
    store: metricstore,
    render: h => h(MetricApp),
    created: () => metricstore.dispatch('initMetricStore')
})